(() => {
  const namespace = window.KGGroutCalculator;

  if (!namespace) {
    return;
  }

  const dispatchCartRefreshEvents = (detail) => {
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail
      })
    );

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail
      })
    );

    document.dispatchEvent(
      new CustomEvent(
        'dispatch:cart-drawer:refresh',
        {
          bubbles: true
        }
      )
    );

    document.dispatchEvent(
      new Event('theme:cart:updated')
    );
  };

  namespace.addRecommendedBundleToCart = async (
    ctx,
    { automatic = false, groupId, translatedAvailability }
  ) => {
    const { bundleCartMessage, bundleCheckbox } = ctx.elements;
    const bundleItems = namespace.getBundleItems(ctx);

    if (
      !bundleCheckbox?.checked ||
      !bundleItems.length ||
      ctx.state.bundleAddInProgress
    ) {
      return;
    }

    ctx.state.bundleAddInProgress = true;

    if (bundleCartMessage) {
      bundleCartMessage.textContent = automatic
        ? 'Lägger till rekommenderade tillbehör…'
        : '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: bundleItems.map((item) => ({
            id: item.id,
            quantity: item.quantity,
            properties: {
              _group_id: groupId,
              _kommod_group: true,
              'Rekommenderad till':
                ctx.calculator.dataset.tileTitle,
              '⛟ ': translatedAvailability
            }
          }))
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkterna kunde inte läggas i varukorgen.'
        );
      }

      if (bundleCartMessage) {
        bundleCartMessage.textContent =
          'Rekommendationerna har lagts i varukorgen.';
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      if (bundleCartMessage) {
        bundleCartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      ctx.state.bundleAddInProgress = false;
    }
  };

  namespace.queueBundleWithMainProduct = (ctx) => {
    const {
      bundleCheckbox,
      bundleCartMessage,
      productForm
    } = ctx.elements;

    const hasExplicitSelectedUpsells =
      Object.keys(window.selectedTilval || {}).length > 0;

    if (hasExplicitSelectedUpsells) {
      if (bundleCheckbox) {
        bundleCheckbox.checked = false;
      }

      if (bundleCartMessage) {
        bundleCartMessage.textContent = '';
      }

      return;
    }

    if (!bundleCheckbox?.checked) {
      return;
    }

    const bundleItems = namespace.getBundleItems(ctx);

    if (!bundleItems.length) {
      return;
    }

    const groupId = Date.now().toString();
    const translatedAvailability =
      namespace.translateDeliveryText(
        productForm?.dataset?.leveranstillganglighet || ''
      );

    window.__kgRecommendationGroupId = groupId;

    const now = Date.now();

    if (now - ctx.state.lastBundleQueueAt < 500) {
      return;
    }

    ctx.state.lastBundleQueueAt = now;

    if (ctx.state.bundleAutoAddTimeout) {
      window.clearTimeout(ctx.state.bundleAutoAddTimeout);
    }

    if (bundleCartMessage) {
      bundleCartMessage.textContent =
        'Tillvalen följer med när produkten läggs i varukorgen…';
    }

    ctx.state.bundleAutoAddTimeout = window.setTimeout(() => {
      namespace.addRecommendedBundleToCart(ctx, {
        automatic: true,
        groupId,
        translatedAvailability
      });
    }, 900);

    window.setTimeout(() => {
      if (window.__kgRecommendationGroupId === groupId) {
        delete window.__kgRecommendationGroupId;
      }
    }, 4000);
  };

  namespace.addRecommendedGroutToCart = async (ctx) => {
    const { addButton, cartMessage } = ctx.elements;
    const {
      groutVariantId,
      groutVariantAvailable,
      jointWidthMm
    } = ctx.data;

    if (
      !Number.isFinite(groutVariantId) ||
      groutVariantId <= 0 ||
      ctx.state.recommendedPackages < 1 ||
      !groutVariantAvailable
    ) {
      return;
    }

    addButton.disabled = true;
    addButton.setAttribute('aria-busy', 'true');

    const originalButtonText = addButton.textContent;
    addButton.textContent = 'Lägger till…';

    if (cartMessage) {
      cartMessage.textContent = '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: groutVariantId,
              quantity: ctx.state.recommendedPackages,
              properties: {
                'Rekommenderad till':
                  ctx.calculator.dataset.tileTitle,
                'Beräknad yta':
                  `${namespace.formatNumber(ctx.state.calculatedAreaM2)} m²`,
                Fogbredd: `${namespace.formatNumber(jointWidthMm)} mm`,
                Plattstorlek:
                  ctx.calculator.dataset.tileDimensions
              }
            }
          ]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkten kunde inte läggas i varukorgen.'
        );
      }

      if (cartMessage) {
        cartMessage.textContent = `${ctx.state.recommendedPackages} ${
          ctx.state.recommendedPackages === 1
            ? 'förpackning har'
            : 'förpackningar har'
        } lagts i varukorgen.`;
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      console.error('Fogkalkylator:', error);

      if (cartMessage) {
        cartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      addButton.removeAttribute('aria-busy');
      addButton.textContent = originalButtonText;
      addButton.disabled =
        ctx.state.recommendedPackages < 1 ||
        !groutVariantAvailable;
    }
  };

  namespace.addRecommendedSiliconeToCart = async (ctx) => {
    const { addSiliconeButton, siliconeCartMessage } =
      ctx.elements;
    const {
      siliconeVariantId,
      siliconeVariantAvailable
    } = ctx.data;

    if (
      !Number.isFinite(siliconeVariantId) ||
      siliconeVariantId <= 0 ||
      ctx.state.recommendedSiliconeUnits < 1 ||
      !siliconeVariantAvailable
    ) {
      return;
    }

    addSiliconeButton.disabled = true;
    addSiliconeButton.setAttribute('aria-busy', 'true');

    const originalButtonText =
      addSiliconeButton.textContent;

    addSiliconeButton.textContent = 'Lägger till…';

    if (siliconeCartMessage) {
      siliconeCartMessage.textContent = '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: siliconeVariantId,
              quantity: ctx.state.recommendedSiliconeUnits,
              properties: {
                'Rekommenderad till':
                  ctx.calculator.dataset.tileTitle,
                Typ: 'Silikonfog'
              }
            }
          ]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkten kunde inte läggas i varukorgen.'
        );
      }

      if (siliconeCartMessage) {
        siliconeCartMessage.textContent = `${
          ctx.state.recommendedSiliconeUnits
        } ${
          ctx.state.recommendedSiliconeUnits === 1
            ? 'patron har'
            : 'patroner har'
        } lagts i varukorgen.`;
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      if (siliconeCartMessage) {
        siliconeCartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      addSiliconeButton.removeAttribute('aria-busy');
      addSiliconeButton.textContent = originalButtonText;
      addSiliconeButton.disabled =
        ctx.state.recommendedSiliconeUnits < 1 ||
        !siliconeVariantAvailable;
    }
  };

  namespace.addRecommendedUnderlayToCart = async (ctx) => {
    const { addUnderlayButton, underlayCartMessage } =
      ctx.elements;
    const {
      underlayVariantId,
      underlayVariantAvailable
    } = ctx.data;

    if (
      !Number.isFinite(underlayVariantId) ||
      underlayVariantId <= 0 ||
      ctx.state.recommendedUnderlayUnits < 1 ||
      !underlayVariantAvailable
    ) {
      return;
    }

    addUnderlayButton.disabled = true;
    addUnderlayButton.setAttribute('aria-busy', 'true');

    const originalButtonText =
      addUnderlayButton.textContent;

    addUnderlayButton.textContent = 'Lägger till…';

    if (underlayCartMessage) {
      underlayCartMessage.textContent = '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: underlayVariantId,
              quantity: ctx.state.recommendedUnderlayUnits,
              properties: {
                'Rekommenderad till':
                  ctx.calculator.dataset.tileTitle
              }
            }
          ]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkten kunde inte läggas i varukorgen.'
        );
      }

      if (underlayCartMessage) {
        underlayCartMessage.textContent = `${
          ctx.state.recommendedUnderlayUnits
        } ${
          ctx.state.recommendedUnderlayUnits === 1
            ? 'rulle har'
            : 'rullar har'
        } lagts i varukorgen.`;
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      if (underlayCartMessage) {
        underlayCartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      addUnderlayButton.removeAttribute('aria-busy');
      addUnderlayButton.textContent = originalButtonText;
      addUnderlayButton.disabled =
        ctx.state.recommendedUnderlayUnits < 1 ||
        !underlayVariantAvailable;
    }
  };

  namespace.addRecommendedPrimerToCart = async (ctx) => {
    const { addPrimerButton, primerCartMessage } =
      ctx.elements;
    const {
      primerVariantId,
      primerVariantAvailable
    } = ctx.data;

    if (
      !Number.isFinite(primerVariantId) ||
      primerVariantId <= 0 ||
      ctx.state.recommendedPrimerUnits < 1 ||
      !primerVariantAvailable
    ) {
      return;
    }

    addPrimerButton.disabled = true;
    addPrimerButton.setAttribute('aria-busy', 'true');

    const originalButtonText = addPrimerButton.textContent;

    addPrimerButton.textContent = 'Lägger till…';

    if (primerCartMessage) {
      primerCartMessage.textContent = '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: primerVariantId,
              quantity: ctx.state.recommendedPrimerUnits,
              properties: {
                'Rekommenderad till':
                  ctx.calculator.dataset.tileTitle
              }
            }
          ]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkten kunde inte läggas i varukorgen.'
        );
      }

      if (primerCartMessage) {
        primerCartMessage.textContent = `${
          ctx.state.recommendedPrimerUnits
        } ${
          ctx.state.recommendedPrimerUnits === 1
            ? 'förpackning har'
            : 'förpackningar har'
        } lagts i varukorgen.`;
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      if (primerCartMessage) {
        primerCartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      addPrimerButton.removeAttribute('aria-busy');
      addPrimerButton.textContent = originalButtonText;
      addPrimerButton.disabled =
        ctx.state.recommendedPrimerUnits < 1 ||
        !primerVariantAvailable;
    }
  };

  namespace.addRecommendedFastmassaToCart = async (ctx) => {
    const { addFastmassaButton, fastmassaCartMessage } =
      ctx.elements;
    const {
      fastmassaVariantId,
      fastmassaVariantAvailable
    } = ctx.data;

    if (
      !Number.isFinite(fastmassaVariantId) ||
      fastmassaVariantId <= 0 ||
      ctx.state.recommendedFastmassaUnits < 1 ||
      !fastmassaVariantAvailable
    ) {
      return;
    }

    addFastmassaButton.disabled = true;
    addFastmassaButton.setAttribute('aria-busy', 'true');

    const originalButtonText =
      addFastmassaButton.textContent;

    addFastmassaButton.textContent = 'Lägger till…';

    if (fastmassaCartMessage) {
      fastmassaCartMessage.textContent = '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: fastmassaVariantId,
              quantity: ctx.state.recommendedFastmassaUnits,
              properties: {
                'Rekommenderad till':
                  ctx.calculator.dataset.tileTitle
              }
            }
          ]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkten kunde inte läggas i varukorgen.'
        );
      }

      if (fastmassaCartMessage) {
        fastmassaCartMessage.textContent = `${
          ctx.state.recommendedFastmassaUnits
        } ${
          ctx.state.recommendedFastmassaUnits === 1
            ? 'säck har'
            : 'säckar har'
        } lagts i varukorgen.`;
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      if (fastmassaCartMessage) {
        fastmassaCartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      addFastmassaButton.removeAttribute('aria-busy');
      addFastmassaButton.textContent = originalButtonText;
      addFastmassaButton.disabled =
        ctx.state.recommendedFastmassaUnits < 1 ||
        !fastmassaVariantAvailable;
    }
  };

  namespace.addRecommendedPassbitarToCart = async (ctx) => {
    const { addPassbitarButton, passbitarCartMessage } =
      ctx.elements;
    const { selectedPassbitarProduct } = ctx.state;

    if (
      !selectedPassbitarProduct ||
      !Number.isFinite(selectedPassbitarProduct.variantId) ||
      selectedPassbitarProduct.variantId <= 0 ||
      ctx.state.recommendedPassbitarUnits < 1 ||
      !selectedPassbitarProduct.available
    ) {
      return;
    }

    addPassbitarButton.disabled = true;
    addPassbitarButton.setAttribute('aria-busy', 'true');

    const originalButtonText =
      addPassbitarButton.textContent;

    addPassbitarButton.textContent = 'Lägger till…';

    if (passbitarCartMessage) {
      passbitarCartMessage.textContent = '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: selectedPassbitarProduct.variantId,
              quantity: ctx.state.recommendedPassbitarUnits,
              properties: {
                'Rekommenderad till':
                  ctx.calculator.dataset.tileTitle
              }
            }
          ]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkten kunde inte läggas i varukorgen.'
        );
      }

      if (passbitarCartMessage) {
        passbitarCartMessage.textContent = `${
          ctx.state.recommendedPassbitarUnits
        } st har lagts i varukorgen.`;
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      if (passbitarCartMessage) {
        passbitarCartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      addPassbitarButton.removeAttribute('aria-busy');
      addPassbitarButton.textContent = originalButtonText;
      addPassbitarButton.disabled =
        ctx.state.recommendedPassbitarUnits < 1 ||
        !selectedPassbitarProduct ||
        !selectedPassbitarProduct.available;
    }
  };

  namespace.addRecommendedPiedestalToCart = async (ctx) => {
    const { addPiedestalButton, piedestalCartMessage } =
      ctx.elements;
    const {
      piedestalVariantId,
      piedestalVariantAvailable
    } = ctx.data;

    if (
      !Number.isFinite(piedestalVariantId) ||
      piedestalVariantId <= 0 ||
      ctx.state.recommendedPiedestalUnits < 1 ||
      !piedestalVariantAvailable
    ) {
      return;
    }

    addPiedestalButton.disabled = true;
    addPiedestalButton.setAttribute('aria-busy', 'true');

    const originalButtonText =
      addPiedestalButton.textContent;

    addPiedestalButton.textContent = 'Lägger till…';

    if (piedestalCartMessage) {
      piedestalCartMessage.textContent = '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: piedestalVariantId,
              quantity: ctx.state.recommendedPiedestalUnits,
              properties: {
                'Rekommenderad till':
                  ctx.calculator.dataset.tileTitle
              }
            }
          ]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkten kunde inte läggas i varukorgen.'
        );
      }

      if (piedestalCartMessage) {
        piedestalCartMessage.textContent = `${
          ctx.state.recommendedPiedestalUnits
        } st har lagts i varukorgen.`;
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      if (piedestalCartMessage) {
        piedestalCartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      addPiedestalButton.removeAttribute('aria-busy');
      addPiedestalButton.textContent = originalButtonText;
      addPiedestalButton.disabled =
        ctx.state.recommendedPiedestalUnits < 1 ||
        !piedestalVariantAvailable;
    }
  };

  namespace.addRecommendedLevelingToCart = async (ctx) => {
    const { addLevelingButton, levelingCartMessage } =
      ctx.elements;
    const { selectedLevelingProduct } = ctx.state;
    const levelingTypeLabel =
      selectedLevelingProduct?.kind === 'band'
        ? 'Nivåband'
        : 'Nivåskruv';

    if (
      !selectedLevelingProduct ||
      !Number.isFinite(selectedLevelingProduct.variantId) ||
      selectedLevelingProduct.variantId <= 0 ||
      ctx.state.recommendedLevelingUnits < 1 ||
      !selectedLevelingProduct.available
    ) {
      return;
    }

    addLevelingButton.disabled = true;
    addLevelingButton.setAttribute('aria-busy', 'true');

    const originalButtonText =
      addLevelingButton.textContent;

    addLevelingButton.textContent = 'Lägger till…';

    if (levelingCartMessage) {
      levelingCartMessage.textContent = '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: selectedLevelingProduct.variantId,
              quantity: ctx.state.recommendedLevelingUnits,
              properties: {
                'Rekommenderad till':
                  ctx.calculator.dataset.tileTitle,
                Typ: levelingTypeLabel,
                Storlek: `${selectedLevelingProduct.size.replace('.', ',')} mm`
              }
            }
          ]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkten kunde inte läggas i varukorgen.'
        );
      }

      if (levelingCartMessage) {
        levelingCartMessage.textContent = `${
          ctx.state.recommendedLevelingUnits
        } ${
          ctx.state.recommendedLevelingUnits === 1
            ? 'förpackning har'
            : 'förpackningar har'
        } lagts i varukorgen.`;
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      if (levelingCartMessage) {
        levelingCartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      addLevelingButton.removeAttribute('aria-busy');
      addLevelingButton.textContent = originalButtonText;
      addLevelingButton.disabled =
        ctx.state.recommendedLevelingUnits < 1 ||
        !selectedLevelingProduct ||
        !selectedLevelingProduct.available;
    }
  };

  namespace.addRecommendedLevelingHatToCart = async (
    ctx
  ) => {
    const {
      addLevelingHatButton,
      levelingHatCartMessage
    } = ctx.elements;
    const { levelingHat } = ctx.data;

    if (
      !levelingHat ||
      !Number.isFinite(levelingHat.variantId) ||
      levelingHat.variantId <= 0 ||
      ctx.state.recommendedLevelingHatUnits < 1 ||
      !levelingHat.available
    ) {
      return;
    }

    addLevelingHatButton.disabled = true;
    addLevelingHatButton.setAttribute('aria-busy', 'true');

    const originalButtonText =
      addLevelingHatButton.textContent;

    addLevelingHatButton.textContent = 'Lägger till…';

    if (levelingHatCartMessage) {
      levelingHatCartMessage.textContent = '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: levelingHat.variantId,
              quantity: ctx.state.recommendedLevelingHatUnits,
              properties: {
                'Rekommenderad till':
                  ctx.calculator.dataset.tileTitle,
                Typ: 'Nivåhatt'
              }
            }
          ]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkten kunde inte läggas i varukorgen.'
        );
      }

      if (levelingHatCartMessage) {
        levelingHatCartMessage.textContent = `${
          ctx.state.recommendedLevelingHatUnits
        } ${
          ctx.state.recommendedLevelingHatUnits === 1
            ? 'förpackning har'
            : 'förpackningar har'
        } lagts i varukorgen.`;
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      if (levelingHatCartMessage) {
        levelingHatCartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      addLevelingHatButton.removeAttribute('aria-busy');
      addLevelingHatButton.textContent = originalButtonText;
      addLevelingHatButton.disabled =
        ctx.state.recommendedLevelingHatUnits < 1 ||
        !levelingHat ||
        !levelingHat.available;
    }
  };

  namespace.addRecommendedLevelingGunToCart = async (
    ctx
  ) => {
    const {
      addLevelingGunButton,
      levelingGunCartMessage
    } = ctx.elements;
    const { levelingGun } = ctx.data;

    if (
      !levelingGun ||
      !Number.isFinite(levelingGun.variantId) ||
      levelingGun.variantId <= 0 ||
      ctx.state.recommendedLevelingGunUnits < 1 ||
      !levelingGun.available
    ) {
      return;
    }

    addLevelingGunButton.disabled = true;
    addLevelingGunButton.setAttribute('aria-busy', 'true');

    const originalButtonText =
      addLevelingGunButton.textContent;

    addLevelingGunButton.textContent = 'Lägger till…';

    if (levelingGunCartMessage) {
      levelingGunCartMessage.textContent = '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: levelingGun.variantId,
              quantity: 1,
              properties: {
                'Rekommenderad till':
                  ctx.calculator.dataset.tileTitle,
                Typ: 'Monteringspistol'
              }
            }
          ]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkten kunde inte läggas i varukorgen.'
        );
      }

      if (levelingGunCartMessage) {
        levelingGunCartMessage.textContent =
          'Monteringspistolen har lagts i varukorgen.';
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      if (levelingGunCartMessage) {
        levelingGunCartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      addLevelingGunButton.removeAttribute('aria-busy');
      addLevelingGunButton.textContent = originalButtonText;
      addLevelingGunButton.disabled =
        ctx.state.recommendedLevelingGunUnits < 1 ||
        !levelingGun ||
        !levelingGun.available;
    }
  };

  namespace.addRecommendedSpacerToCart = async (ctx) => {
    const { addSpacerButton, spacerCartMessage } =
      ctx.elements;
    const { selectedSpacerProduct } = ctx.state;

    if (
      !selectedSpacerProduct ||
      !Number.isFinite(selectedSpacerProduct.variantId) ||
      selectedSpacerProduct.variantId <= 0 ||
      ctx.state.recommendedSpacerUnits < 1 ||
      !selectedSpacerProduct.available
    ) {
      return;
    }

    addSpacerButton.disabled = true;
    addSpacerButton.setAttribute('aria-busy', 'true');

    const originalButtonText =
      addSpacerButton.textContent;

    addSpacerButton.textContent = 'Lägger till…';

    if (spacerCartMessage) {
      spacerCartMessage.textContent = '';
    }

    try {
      const rootRoute = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${rootRoute}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: selectedSpacerProduct.variantId,
              quantity: ctx.state.recommendedSpacerUnits,
              properties: {
                'Rekommenderad till':
                  ctx.calculator.dataset.tileTitle,
                Typ: 'Kakelkryss',
                Storlek: `${selectedSpacerProduct.size.replace('.', ',')} mm`
              }
            }
          ]
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'Produkten kunde inte läggas i varukorgen.'
        );
      }

      if (spacerCartMessage) {
        spacerCartMessage.textContent = `${
          ctx.state.recommendedSpacerUnits
        } ${
          ctx.state.recommendedSpacerUnits === 1
            ? 'förpackning har'
            : 'förpackningar har'
        } lagts i varukorgen.`;
      }

      dispatchCartRefreshEvents(responseData);
    } catch (error) {
      if (spacerCartMessage) {
        spacerCartMessage.textContent =
          error.message || 'Något gick fel. Försök igen.';
      }
    } finally {
      addSpacerButton.removeAttribute('aria-busy');
      addSpacerButton.textContent = originalButtonText;
      addSpacerButton.disabled =
        ctx.state.recommendedSpacerUnits < 1 ||
        !selectedSpacerProduct ||
        !selectedSpacerProduct.available;
    }
  };
})();
